import { lazy } from 'react';
import { Route, RouteMenu } from './routes.type';
import { 
  MdDashboard, 
  MdReceipt, 
  MdAttachMoney, 
  MdPeople, 
  MdBusiness, 
  MdShoppingCart, 
  MdAccountBalance, 
  MdAccountBalanceWallet, 
  MdPayment, 
  MdAccountTree, 
  MdSwapHoriz, 
  MdAssessment, 
  MdInventory 
} from 'react-icons/md';

const DashboardPage = lazy(() => import('../pages/Accounting/Dashboard.page'));
const InvoicesPage = lazy(() => import('../pages/Accounting/Invoices.page'));
const InvoiceDetailPage = lazy(() => import('../pages/Accounting/InvoiceDetail.page'));
const InvoiceFormPage = lazy(() => import('../pages/Accounting/InvoiceForm.page'));
const ExpensesPage = lazy(() => import('../pages/Accounting/Expenses.page'));
const ExpenseFormPage = lazy(() => import('../pages/Accounting/ExpenseForm.page'));
const ExpenseDetailPage = lazy(() => import('../pages/Accounting/ExpenseDetail.page'));
const CustomersPage = lazy(() => import('../pages/Accounting/Customers.page'));
const CustomerDetailPage = lazy(() => import('../pages/Accounting/CustomerDetail.page'));
const CustomerFormPage = lazy(() => import('../pages/Accounting/CustomerForm.page'));
const VendorsPage = lazy(() => import('../pages/Accounting/Vendors.page'));
const VendorDetailPage = lazy(() => import('../pages/Accounting/VendorDetail.page'));
const VendorFormPage = lazy(() => import('../pages/Accounting/VendorForm.page'));
const PurchaseOrdersPage = lazy(() => import('../pages/Accounting/PurchaseOrders.page'));
const PurchaseOrderFormPage = lazy(() => import('../pages/Accounting/PurchaseOrderForm.page'));
const PurchaseOrderDetailPage = lazy(() => import('../pages/Accounting/PurchaseOrderDetail.page'));
const PayablePage = lazy(() => import('../pages/Accounting/Payable.page'));
const ReceivablePage = lazy(() => import('../pages/Accounting/Receivable.page'));
const PaymentsPage = lazy(() => import('../pages/Accounting/Payments.page'));
const PaymentFormPage = lazy(() => import('../pages/Accounting/PaymentForm.page'));
const PaymentDetailPage = lazy(() => import('../pages/Accounting/PaymentDetail.page'));
const AccountsPage = lazy(() => import('../pages/Accounting/Accounts.page'));
const AccountFormPage = lazy(() => import('../pages/Accounting/AccountForm.page'));
const AccountDetailPage = lazy(() => import('../pages/Accounting/AccountDetail.page'));
const TransactionsPage = lazy(() => import('../pages/Accounting/Transactions.page'));
const ReportsPage = lazy(() => import('../pages/Accounting/Reports.page'));
const InventoryPage = lazy(() => import('../pages/Accounting/Inventory.page'));
const InventoryFormPage = lazy(() => import('../pages/Accounting/InventoryForm.page'));
const InventoryDetailPage = lazy(() => import('../pages/Accounting/InventoryDetail.page'));

export const routes: Route[] = [
  {
    path: '/accounting/dashboard',
    component: DashboardPage,
    permission: 'accounting.dashboard',
    name: 'Dashboard Akuntansi',
    title: 'Dashboard Akuntansi'
  },
  {
    path: '/accounting/invoices',
    component: InvoicesPage,
    permission: 'accounting.invoices',
    name: 'Faktur',
    title: 'Faktur'
  },
  {
    path: '/accounting/invoices/new',
    component: InvoiceFormPage,
    permission: 'accounting.invoices.create',
    name: 'Buat Faktur',
    title: 'Buat Faktur'
  },
  {
    path: '/accounting/invoices/:id',
    component: InvoiceDetailPage,
    permission: 'accounting.invoices.view',
    name: 'Detail Faktur',
    title: 'Detail Faktur'
  },
  {
    path: '/accounting/invoices/:id/edit',
    component: InvoiceFormPage,
    permission: 'accounting.invoices.edit',
    name: 'Edit Faktur',
    title: 'Edit Faktur'
  },
  {
    path: '/accounting/expenses',
    component: ExpensesPage,
    permission: 'accounting.expenses',
    name: 'Pengeluaran',
    title: 'Pengeluaran'
  },
  {
    path: '/accounting/expenses/new',
    component: ExpenseFormPage,
    permission: 'accounting.expenses.create',
    name: 'Tambah Pengeluaran',
    title: 'Tambah Pengeluaran'
  },
  {
    path: '/accounting/expenses/:id',
    component: ExpenseDetailPage,
    permission: 'accounting.expenses.view',
    name: 'Detail Pengeluaran',
    title: 'Detail Pengeluaran'
  },
  {
    path: '/accounting/expenses/:id/edit',
    component: ExpenseFormPage,
    permission: 'accounting.expenses.edit',
    name: 'Edit Pengeluaran',
    title: 'Edit Pengeluaran'
  },
  {
    path: '/accounting/customers',
    component: CustomersPage,
    permission: 'accounting.customers',
    name: 'Pelanggan',
    title: 'Pelanggan'
  },
  {
    path: '/accounting/customers/new',
    component: CustomerFormPage,
    permission: 'accounting.customers.create',
    name: 'Tambah Pelanggan',
    title: 'Tambah Pelanggan'
  },
  {
    path: '/accounting/customers/:id',
    component: CustomerDetailPage,
    permission: 'accounting.customers.view',
    name: 'Detail Pelanggan',
    title: 'Detail Pelanggan'
  },
  {
    path: '/accounting/customers/:id/edit',
    component: CustomerFormPage,
    permission: 'accounting.customers.edit',
    name: 'Edit Pelanggan',
    title: 'Edit Pelanggan'
  },
  {
    path: '/accounting/vendors',
    component: VendorsPage,
    permission: 'accounting.vendors',
    name: 'Vendor',
    title: 'Vendor'
  },
  {
    path: '/accounting/vendors/new',
    component: VendorFormPage,
    permission: 'accounting.vendors.create',
    name: 'Tambah Vendor',
    title: 'Tambah Vendor'
  },
  {
    path: '/accounting/vendors/:id',
    component: VendorDetailPage,
    permission: 'accounting.vendors.view',
    name: 'Detail Vendor',
    title: 'Detail Vendor'
  },
  {
    path: '/accounting/vendors/:id/edit',
    component: VendorFormPage,
    permission: 'accounting.vendors.edit',
    name: 'Edit Vendor',
    title: 'Edit Vendor'
  },
  {
    path: '/accounting/purchase-orders',
    component: PurchaseOrdersPage,
    permission: 'accounting.purchase_orders',
    name: 'Pesanan Pembelian',
    title: 'Pesanan Pembelian'
  },
  {
    path: '/accounting/purchase-orders/new',
    component: PurchaseOrderFormPage,
    permission: 'accounting.purchase_orders.create',
    name: 'Buat Pesanan Pembelian',
    title: 'Buat Pesanan Pembelian'
  },
  {
    path: '/accounting/purchase-orders/:id',
    component: PurchaseOrderDetailPage,
    permission: 'accounting.purchase_orders.view',
    name: 'Detail Pesanan Pembelian',
    title: 'Detail Pesanan Pembelian'
  },
  {
    path: '/accounting/purchase-orders/:id/edit',
    component: PurchaseOrderFormPage,
    permission: 'accounting.purchase_orders.edit',
    name: 'Edit Pesanan Pembelian',
    title: 'Edit Pesanan Pembelian'
  },
  {
    path: '/accounting/payable',
    component: PayablePage,
    permission: 'accounting.payable',
    name: 'Hutang Usaha',
    title: 'Hutang Usaha'
  },
  {
    path: '/accounting/receivable',
    component: ReceivablePage,
    permission: 'accounting.receivable',
    name: 'Piutang Usaha',
    title: 'Piutang Usaha'
  },
  {
    path: '/accounting/payments',
    component: PaymentsPage,
    permission: 'accounting.payments',
    name: 'Pembayaran',
    title: 'Pembayaran'
  },
  {
    path: '/accounting/payments/new',
    component: PaymentFormPage,
    permission: 'accounting.payments.create',
    name: 'Catat Pembayaran',
    title: 'Catat Pembayaran'
  },
  {
    path: '/accounting/payments/:id',
    component: PaymentDetailPage,
    permission: 'accounting.payments.view',
    name: 'Detail Pembayaran',
    title: 'Detail Pembayaran'
  },
  {
    path: '/accounting/payments/:id/edit',
    component: PaymentFormPage,
    permission: 'accounting.payments.edit',
    name: 'Edit Pembayaran',
    title: 'Edit Pembayaran'
  },
  {
    path: '/accounting/accounts',
    component: AccountsPage,
    permission: 'accounting.accounts',
    name: 'Daftar Akun',
    title: 'Daftar Akun'
  },
  {
    path: '/accounting/accounts/new',
    component: AccountFormPage,
    permission: 'accounting.accounts.create',
    name: 'Tambah Akun',
    title: 'Tambah Akun'
  },
  {
    path: '/accounting/accounts/:id',
    component: AccountDetailPage,
    permission: 'accounting.accounts.view',
    name: 'Detail Akun',
    title: 'Detail Akun'
  },
  {
    path: '/accounting/accounts/:id/edit',
    component: AccountFormPage,
    permission: 'accounting.accounts.edit',
    name: 'Edit Akun',
    title: 'Edit Akun'
  },
  {
    path: '/accounting/transactions',
    component: TransactionsPage,
    permission: 'accounting.transactions',
    name: 'Transaksi',
    title: 'Transaksi'
  },
  {
    path: '/accounting/reports',
    component: ReportsPage,
    permission: 'accounting.reports',
    name: 'Laporan',
    title: 'Laporan'
  },
  {
    path: '/accounting/inventory',
    component: InventoryPage,
    permission: 'accounting.inventory',
    name: 'Persediaan',
    title: 'Persediaan'
  },
  {
    path: '/accounting/inventory/new',
    component: InventoryFormPage,
    permission: 'accounting.inventory.create',
    name: 'Tambah Item Persediaan',
    title: 'Tambah Item Persediaan'
  },
  {
    path: '/accounting/inventory/:id/edit',
    component: InventoryFormPage,
    permission: 'accounting.inventory.edit',
    name: 'Edit Item Persediaan',
    title: 'Edit Item Persediaan'
  },
  {
    path: '/accounting/inventory/:id',
    component: InventoryDetailPage,
    permission: 'accounting.inventory.view',
    name: 'Detail Item Persediaan',
    title: 'Detail Item Persediaan'
  }
];

export const menus: RouteMenu[] = [
  {
    path: '/accounting/dashboard',
    name: 'Dashboard Akuntansi',
    title: 'Dashboard Akuntansi',
    icon: MdDashboard,
    permission: 'master data',
    isSidebarMenu: true
  },
  {
    path: '/accounting',
    name: 'Akuntansi',
    title: 'Akuntansi',
    icon: MdAccountBalance,
    permission: 'master data',
    isSidebarMenu: true,
    subMenu: [
      {
        path: '/accounting/dashboard',
        name: 'Dashboard Akuntansi',
        title: 'Dashboard Akuntansi',
        icon: MdDashboard,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/invoices',
        name: 'Faktur',
        title: 'Faktur',
        icon: MdReceipt,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/expenses',
        name: 'Pengeluaran',
        title: 'Pengeluaran',
        icon: MdAttachMoney,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/customers',
        name: 'Pelanggan',
        title: 'Pelanggan',
        icon: MdPeople,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/vendors',
        name: 'Vendor',
        title: 'Vendor',
        icon: MdBusiness,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/purchase-orders',
        name: 'Pesanan Pembelian',
        title: 'Pesanan Pembelian',
        icon: MdShoppingCart,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/payable',
        name: 'Hutang Usaha',
        title: 'Hutang Usaha',
        icon: MdAccountBalance,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/receivable',
        name: 'Piutang Usaha',
        title: 'Piutang Usaha',
        icon: MdAccountBalanceWallet,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/payments',
        name: 'Pembayaran',
        title: 'Pembayaran',
        icon: MdPayment,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/accounts',
        name: 'Daftar Akun',
        title: 'Daftar Akun',
        icon: MdAccountTree,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/transactions',
        name: 'Transaksi',
        title: 'Transaksi',
        icon: MdSwapHoriz,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/reports',
        name: 'Laporan',
        title: 'Laporan',
        icon: MdAssessment,
        permission: 'master data',
        isSidebarMenu: true
      },
      {
        path: '/accounting/inventory',
        name: 'Persediaan',
        title: 'Persediaan',
        icon: MdInventory,
        permission: 'master data',
        isSidebarMenu: true
      }
    ]
  }
];

export default {
  routes,
  menus
};
